import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import DefaultLoader from "components/common/DefaultLoader";
import { useRetroactiveDateSupport } from "components/layers/retroactiveDateSupport";
import * as labels from "config.labels";
import { useDispatch } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as pricingActions from "store/actions/pricing/pricingActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const LOADING_KEY = "__LOADING__";
const NONE_KEY = "__NONE__";

const PolicyTypeSelector = ({
  choices,
  value,
  onChange,
  isLoading,
  disabled,
}) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  return (
    <FormControl variant={"filled"} fullWidth>
      <InputLabel className={"input-label"}>
        {translateLabel(labels.POLICY_TYPE_LABEL, {
          default: "Policy Type",
        })}
      </InputLabel>
      <Select
        value={isLoading ? LOADING_KEY : !!value ? value : NONE_KEY}
        onChange={(event) => {
          const value = event?.target?.value ?? NONE_KEY;
          if (!value || value === NONE_KEY) {
            onChange(null);
          } else if (value !== LOADING_KEY) {
            onChange(value);
          }
        }}
        disabled={isLoading || disabled}
        fullWidth
      >
        {isLoading && (
          <MenuItem value={LOADING_KEY}>
            <DefaultLoader
              size={16}
              style={{
                display: "block",
                textAlign: "center",
              }}
            />
          </MenuItem>
        )}
        <MenuItem value={NONE_KEY}>
          {translateLabel(labels.POLICY_TYPE_NONE_OPTION, {
            default: "None",
          })}
        </MenuItem>
        {(choices ?? []).map(({ key, name }) => (
          <MenuItem key={key} value={key}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const PolicyType = ({ disabled }) => {
  const dispatch = useDispatch();

  const {
    data: policyTypeConfig,
    isLoading,
  } = staticDataService.useConfigQuery("policy_types");

  const { supports, layer } = useRetroactiveDateSupport();

  // The retroactive date picker itself is rendered by <RetroactiveDate />,
  // which shows when either the policy type or the policy form supports one.
  return (
    <Grid item xs={12}>
      <PolicyTypeSelector
        choices={policyTypeConfig?.choices}
        value={layer?.policyType}
        onChange={(value) => {
          if (value !== layer?.policyType) {
            const values = { policyType: value };
            if (!supports(value, layer?.policyForm)) {
              values.retroactiveDate = null;
            }
            dispatch(
              pricingActions.updateLayer({
                layerId: layer.id,
                values,
              })
            );
          }
        }}
        isLoading={isLoading}
        disabled={disabled || !policyTypeConfig?.choices?.length}
      />
    </Grid>
  );
};

export default PolicyType;
